import React from 'react';
import { BaseUiModificationsContainer } from '@atlassian/ui-modifications-core/controllers';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { ContainerComponent } from '@atlassian/react-sweet-state';
import { GIC_VIEW_TYPE } from '../../common/constants/index.tsx';
import { GICViewConfiguration } from '../../common/utils/configuration/index.tsx';

export const UiModificationsContainer: ContainerComponent<unknown> = ({ children }) => (
	<BaseUiModificationsContainer
		scope={GIC_VIEW_TYPE}
		viewType={GIC_VIEW_TYPE}
		viewConfiguration={GICViewConfiguration}
	>
		{children}
	</BaseUiModificationsContainer>
);
